import axios from "axios";

const api = axios.create({
    baseURL: "https://hrmsbackend-lxwl.onrender.com",
    headers: {
    "Content-Type": "application/json",
  },
});

export default api;
